
    <fieldmagic-primary-button
      icon="history"
      label="View History"
      (click)="onClick()"
    >
    </fieldmagic-primary-button>
  